import { Box, Grid } from "@mui/material";
import { IAds } from "../interfaces/IAds";
import AdsComponent from "./AdsComponent";
import { Helmet } from "react-helmet-async";

const HeadAd: React.FC<{ banner: IAds }> = ({ banner }) => {
  return (
    <Grid container>
       {banner?.script_url && (
            <Helmet>
              <script src={banner?.script_url} async></script>
            </Helmet>
          )}
      <Grid item xs={12}>
        {banner && banner.image && (
          <img
            src={banner?.image_url}
            style={{
              width: banner.display_width ?? 728,
              height: banner.display_height ?? 90,
            }}
          />
        )}
        {banner && banner.ad_script && (
          <div
            className="mt-4"
            dangerouslySetInnerHTML={{
              __html: banner?.ad_script as string,
            }}
          />
        )}
        {banner && banner.ad_slot && <AdsComponent data={banner} />}
      </Grid>
    </Grid>
  );
};

export default HeadAd;
